import React, {useState} from "react";
import {useTranslation} from "react-i18next";
import {
  ClickableUrlContent,
  CodeContainer,
  CodeContent,
  CodeHeader,
  CopyButton,
  ExternalLinkIcon,
  Language
} from "./styles";
import { ReactComponent as ExternalLinkSvg } from "assets/icons/external-link.svg";

const CodeBlock = ({ code, language, title, url }) => {
  const [copied, setCopied] = useState(false);
  const { t } = useTranslation();

  const copyToClipboard = () => {
    navigator.clipboard.writeText(code);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <CodeContainer className="code-block">
      <CodeHeader>
        <Language>{title || language}</Language>
        <CopyButton onClick={copyToClipboard}>
          {copied ? t("buttons.copied") : t("buttons.copy")}
        </CopyButton>
      </CodeHeader>
      <CodeContent>
        {url ? (
          <ClickableUrlContent href={url} target="_blank" rel="noopener noreferrer">
            <code>{code}</code>
            <ExternalLinkIcon src={ExternalLinkSvg} alt="Opens in new tab" />
          </ClickableUrlContent>
        ) : (
          <pre>
            <code>{code}</code>
          </pre>
        )}
      </CodeContent>
    </CodeContainer>
  );
};

export default CodeBlock;